import React, {Fragment, useState, useEffect} from 'react';
import i18n from 'i18next';
import {ButtonBorderless} from "@/Components/Buttons/ButtonBorderless";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";
import "../../../sass/components/FilterSlider.scss";
import { CheckboxDropdown } from "../../Components/CheckboxDropdown";

export default function FilterSlider({state,
                                         dispatch,
                                         statusItems,
                                         setStatusItems,
                                         accountTypeItems,
                                         setAccountTypeItems,
                                         moduleAccessItems,
                                         setModuleAccessItems}) {

    const [sliderOpen, setSliderOpen] = useState(false);

    function closeFilterSlider() {
        dispatch({ type: "showFilterSlider", payload: { showFilterSlider: false }});

        /* Needed in order to animate the slider close */
        setTimeout(function(){
            dispatch({ type: "filterSliderReady", payload: { filterSliderReady: false }});
        }, 500);
    }

    const clearFilters = () => {
        setStatusItems(
            statusItems.map((item) => {
                return { id: item.id, label: i18n.t("filter-slider." + item.id.toLowerCase().replaceAll(' ', '-')), checked: false };
            })
        );
        setAccountTypeItems(
            accountTypeItems.map((item) => {
                return { id: item.id, label: i18n.t("filter-slider." + item.id.toLowerCase().replaceAll(' ', '-')), checked: false };
            })
        );
        setModuleAccessItems(
            moduleAccessItems.map((item) => {
                return { id: "module-" + item.slug, label: item.name, checked: false };
            })
        );
    }

    const applyFilters = () => {

        let statusFilters = statusItems.filter(item => item.checked === true)
            .map(checkedItem => checkedItem.label);
        let accountFilters = accountTypeItems.filter(item => item.checked === true)
            .map(checkedItem => checkedItem.label);
        let moduleFilters = moduleAccessItems.filter(item => item.checked === true)
            .map(checkedItem => checkedItem.label);

        dispatch({ type: "filters", payload: { filters: [...statusFilters, ...accountFilters, ...moduleFilters] }})

        closeFilterSlider();
    };

    useEffect(() => {
        /* Animate the opening and closing of the slider */
        if (state.showFilterSlider !== sliderOpen) {
            setSliderOpen(!sliderOpen);
        }
    }, [state.showFilterSlider])

    return (
        <Fragment>
            {sliderOpen && <div className={"fade modal-backdrop slider-backdrop show"}/>}
            <div className={sliderOpen ? "add-filter-slider slider show" : "add-filter-slider slider"}>
                <div className="slider-header">
                    <div className="slider-title">{i18n.t("filter-slider.title")}</div>
                    <div className="close-slider">
                        <i onClick={closeFilterSlider} className="fa fa-times"></i>
                    </div>
                </div>
                <div className="slider-body" data-testid="filter_slider-div-slider_body">
                    <CheckboxDropdown items={statusItems} setItems={setStatusItems}
                                      label={statusItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).length > 0 ?
                                        statusItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).join(', ') : "Status" }
                                      dataTestid="filter_slider-checkdropdown-status"

                    />
                    <CheckboxDropdown items={accountTypeItems} setItems={setAccountTypeItems}
                                      label={accountTypeItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).length > 0 ?
                                          accountTypeItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).join(', ') : "Account Type" }
                                      dataTestid="filter_slider-checkdropdown-account_type"
                    />
                    <CheckboxDropdown items={moduleAccessItems} setItems={setModuleAccessItems}
                                      label={moduleAccessItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).length > 0 ?
                                          moduleAccessItems.filter(item => item.checked === true).map(checkedItem => checkedItem.label).join(', ') : "Module Access" }
                                      dataTestid="filter_slider-checkdropdown-module_access"
                    />

                    <ButtonBorderless onClick={clearFilters} dataTestid="filter_slider-button-clear_filters">Clear Filters</ButtonBorderless>
                    <ButtonPrimary onClick={applyFilters} dataTestid="filter_slider-button-apply_filters">Apply</ButtonPrimary>
                </div>
            </div>
        </Fragment>
    );
}
